import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';


export const BankingInformationForm = ({ dto, errorInputs, handleInputChange, t }) => {

    return (
        <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid size={{ xs: 12}}>
                <Typography variant="h6">{t("suppliers.bankInformation")}</Typography>
            </Grid>

            <Grid size={{ xs: 4, sm: 4 }}>
                <FormControl
                    fullWidth
                    size='small'
                    error={Boolean(errorInputs.type_account?.isError)}
                    required
                >
                    <InputLabel id="account-type-label">{t("suppliers.bank.accountType")}</InputLabel>
                    <Select
                        label={t("suppliers.bank.accountType")}
                        name='type_account'
                        value={dto.type_account}
                        onChange={handleInputChange}
                    >
                        <MenuItem value="Corriente">{t("suppliers.bank.checking")}</MenuItem>
                        <MenuItem value="Ahorros">{t("suppliers.bank.savings")}</MenuItem>
                    </Select>
                    {errorInputs.type_account?.isError && (
                        <FormHelperText>{errorInputs.type_account.messageError}</FormHelperText>
                    )}
                </FormControl>
            </Grid>

            <Grid size={{ xs: 4, sm: 4 }}>
                <TextField
                    fullWidth
                    size="small"
                    label={t("suppliers.bank.accountNumber")}
                    name='number_account'
                    value={dto.number_account}
                    onChange={handleInputChange}
                    error={!!errorInputs.number_account?.isError}
                    helperText={errorInputs.number_account?.messageError}
                    required
                />
            </Grid>

            <Grid size={{ xs: 4, sm: 4 }}>
                <TextField
                    fullWidth
                    size="small"
                    name='banking_company'
                    label={t("suppliers.bank.bankName")}
                    value={dto.banking_company}
                    onChange={handleInputChange}
                    error={!!errorInputs.banking_company?.isError}
                    helperText={errorInputs.banking_company?.messageError}
                    required
                />
            </Grid>

            <Grid size={{ xs: 4, sm: 4 }}>
                <TextField
                    fullWidth
                    size="small"
                    label={t("suppliers.bank.branchName")}
                    name='banking_office'
                    value={dto.banking_office}
                    onChange={handleInputChange}
                    error={!!errorInputs.banking_office?.isError}
                    helperText={errorInputs.banking_office?.messageError}
                    required
                />
            </Grid>
        </Grid>
    );
};
